"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _source = require("../source");
var _stageFeaturedPresenter = _interopRequireDefault(require("./stageFeaturedPresenter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function syncFeaturePresenter(presenterId) {
  return function (dispatch) {
    dispatch((0, _source.getSources)());
    dispatch((0, _stageFeaturedPresenter["default"])(presenterId));
  };
}
var _default = exports["default"] = syncFeaturePresenter;